import request from "@/utils/request";

const { ElMessage } = require("element-plus");

export default {
  name: "BuildingInfo",
  components: {},
  data() {
    const checkStuNum = (rule, value, callback) => {
      request.get("/stu/exist/" + value).then((res) => {
        request.get("/room/judgeHadBed/" + value).then((result) => {
          if (res.code === "0" && result.code === "0") {
            callback();
          } else if (res.code === "-1" && result.code === "0") {
            callback(new Error(res.msg));
          } else if (res.code === "0" && result.code === "-1") {
            callback(new Error(result.msg));
          } else {
            callback(new Error("请输入正确的数据"));
          }
        });
      });
    };
    return {
      bedNum: 0,
      havePeopleNum: 0,
      loading: true,
      disabled: false,
      judge: false,
      dialogVisible: false,
      bedDialog: false,
      stuInfoDialog: false,
      bedName: "",
      search: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {
        dormRoomId: "",
        dormBuildId: "",
        floorNum: "",
        maxCapacity: "",
        currentCapacity: "",
        firstBed: "",
        secondBed: "",
        thirdBed: "",
        fourthBed: "",
        status: "1",
      },
      rules: {
        dormRoomId: [
          { required: true, message: "请输入房间号", trigger: "blur" },
          {
            pattern: /^[0-9]{4}$/,
            message: "范围：1000-9999",
            trigger: "blur",
          },
        ],
        floorNum: [
          { required: true, message: "请输入楼层数", trigger: "blur" },
          { pattern: /^[1-9]$/, message: "范围：1-9", trigger: "blur" },
        ],
        dormBuildId: [
          { required: true, message: "请输入楼宇号数", trigger: "blur" },
          { pattern: /^[1-9]$/, message: "范围：1-9", trigger: "blur" },
        ],
        maxCapacity: [
          { required: true, message: "请输入房间可住人数", trigger: "blur" },
          { pattern: /^[0-4]$/, message: "范围：0-4", trigger: "blur" },
        ],
        currentCapacity: [
          { required: true, message: "请输入当前已住人数", trigger: "blur" },
          { pattern: /^[0-4]$/, message: "范围：0-4", trigger: "blur" },
        ],
        firstBed: [{ validator: checkStuNum, trigger: "blur" }],
        secondBed: [{ validator: checkStuNum, trigger: "blur" }],
        thirdBed: [{ validator: checkStuNum, trigger: "blur" }],
        fourthBed: [{ validator: checkStuNum, trigger: "blur" }],
      },
      stuOptions: [],
      stuLoading: false,
      isCheckedIn: 1,
      currentCapacityFilter: null,
      multipleSelection: [],
      importRoomDialogVisible: false,
      importRoomFile: null,
    };
  },
  created() {
    // 获取query参数
    console.log(this.$route.query.isCheckedIn);

    if (this.$route.query.isCheckedIn === '0') {
      this.isCheckedIn = 0;
    }
    this.load();
    this.loading = true;
    setTimeout(() => {
      //设置延迟执行
      this.loading = false;
    }, 1000);
  },
  methods: {
    checkOutRoom() {
      const ids = this.multipleSelection.map(item => item.dormRoomId).filter(id => id != null && id != undefined);
      console.log('批量退房选中的ids:', ids);

      if (!ids || ids.length === 0) {
        ElMessage({ message: "请选择要退房的房间", type: "warning" });
        return;
      }

      request.post("/room/batchReset", { ids: ids }).then((res) => {
        if (res.code === "0") {
          ElMessage({
            message: res.msg || "操作成功",
            type: "success",
          });
          this.$refs.multipleTable.clearSelection();
          this.load(); // 刷新数据
        } else {
          ElMessage({
            message: res.msg || "操作失败",
            type: "error",
          });
        }
      }).catch((err) => {
        console.error('批量退房请求失败:', err);
        ElMessage({
          message: "批量退房请求失败: " + (err.message || "未知错误"),
          type: "error",
        });
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    remoteMethod(query) {
      if (query) {
        this.stuLoading = true;
        request
          .get("/stu/find", {
            params: {
              pageNum: 1,
              pageSize: 20,
              search: query,
            },
          })
          .then((res) => {
            this.stuLoading = false;
            this.stuOptions = res.data.records;
          });
      } else {
        this.stuOptions = [];
      }
    },
    switchHandle() {
      this.currentPage = 1;
      this.load();
    },
    async load() {
      request
        .get("/room/find", {
          params: {
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            search: this.search,
            isCheckedIn: this.isCheckedIn,
            currentCapacity: this.currentCapacityFilter,
          },
        })
        .then((res) => {
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.loading = false;
        });
    },
    reset() {
      this.search = "";
      this.isCheckedIn = 1;
      this.currentCapacityFilter = null;
      this.currentPage = 1;
      this.load();
    },
    filterTag(value, row) {
      return row.currentCapacity === value;
    },
    handleCapacityFilter() {
      this.currentPage = 1;
      this.load();
    },
    add() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.disabled = false;
        this.form = {
          status: "1",
        };
        this.judge = false;
      });
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.judge === false) {
            //新增
            request.post("/room/add", this.form).then((res) => {
              if (res.code === "0") {
                ElMessage({
                  message: "新增成功",
                  type: "success",
                });
                this.search = "";
                this.loading = true;
                this.load();
                this.dialogVisible = false;
              } else {
                ElMessage({
                  message: res.msg,
                  type: "error",
                });
              }
            });
          } else {
            //修改
            request.put("/room/edit", this.form).then((res) => {
              if (res.code === "0") {
                ElMessage({
                  message: "修改成功",
                  type: "success",
                });
                this.search = "";
                this.load();
                this.dialogVisible = false;
              } else {
                ElMessage({
                  message: res.msg,
                  type: "error",
                });
              }
            });
          }
        }
      });
    },
    cancel() {
      this.$refs.form.resetFields();
      this.dialogVisible = false;
      this.bedDialog = false;
      this.stuInfoDialog = false;
    },
    handleEdit(row) {
      //修改
      this.judge = true;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        // 生拷贝
        this.form = JSON.parse(JSON.stringify(row));
        this.disabled = true;
      });
    },
    handleDelete(dormRoomId) {
      //删除
      request.delete("/room/delete/" + dormRoomId).then((res) => {
        if (res.code === "0") {
          ElMessage({
            message: "删除成功",
            type: "success",
          });
          this.search = "";
          this.load();
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    calCurrentNum(info) {
      this.havePeopleNum = 0;
      // 获取房间人数
      let roomPeopleNum = 0;
      if (info.firstBed != null) {
        roomPeopleNum++;
      }
      if (info.secondBed != null) {
        roomPeopleNum++;
      }
      if (info.thirdBed != null) {
        roomPeopleNum++;
      }
      if (info.fourthBed != null) {
        roomPeopleNum++;
      }
      this.havePeopleNum = roomPeopleNum;
    },
    plusIcon(num, info) {
      //添加图标
      this.judge = false;
      //显示对应床位input
      this.bedNum = num;
      //获取当前房间人数
      this.calCurrentNum(info);
      this.bedDialog = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        // 生拷贝
        this.form = JSON.parse(JSON.stringify(info));
      });
    },
    editIcon(num, info) {
      //修改图标
      this.judge = true;
      //显示对应床位input
      this.bedNum = num;
      //修改床位所住的学生
      this.bedDialog = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        // 生拷贝
        this.form = JSON.parse(JSON.stringify(info));
      });
    },
    detailIcon(num, info) {
      //查看床位所住的学生
      let stu = "";
      // 删除
      if (num === 1) {
        stu = info.firstBed;
      } else if (num === 2) {
        stu = info.secondBed;
      } else if (num === 3) {
        stu = info.thirdBed;
      } else if (num === 4) {
        stu = info.fourthBed;
      }
      request.get("/stu/exist/" + stu).then((res) => {
        if (res.code === "0") {
          this.stuInfoDialog = true;
          this.$nextTick(() => {
            this.$refs.form.resetFields();
            // 生拷贝
            this.form = JSON.parse(JSON.stringify(res.data));
          });
        }
      });
    },
    addStuBed() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 为床位添加学生
          this.form.currentCapacity = this.havePeopleNum + 1;
          request.put("/room/update", this.form).then((res) => {
            if (res.code === "0") {
              ElMessage({
                message: "新增成功",
                type: "success",
              });
              this.search = "";
              this.loading = true;
              this.load();
              this.bedDialog = false;
            } else {
              ElMessage({
                message: res.msg,
                type: "error",
              });
            }
          });
        }
      });
    },
    editStuBed() {
      //修改
      this.$refs.form.validate((valid) => {
        if (valid) {
          request.put("/room/update", this.form).then((res) => {
            if (res.code === "0") {
              ElMessage({
                message: "修改成功",
                type: "success",
              });
              this.search = "";
              this.loading = true;
              this.load();
              this.bedDialog = false;
            } else {
              ElMessage({
                message: res.msg,
                type: "error",
              });
            }
          });
        }
      });
    },
    async deleteStuBed(bedNum, info) {
      let bedName = "";
      // 删除
      if (bedNum === 1) {
        bedName = "first_bed";
      } else if (bedNum === 2) {
        bedName = "second_bed";
      } else if (bedNum === 3) {
        bedName = "third_bed";
      } else if (bedNum === 4) {
        bedName = "fourth_bed";
      }
      //更新当前房间人数
      this.calCurrentNum(info);
      request
        .delete(
          "/room/delete/" +
          bedName +
          "/" +
          info.dormRoomId +
          "/" +
          this.havePeopleNum
        )
        .then((res) => {
          if (res.code === "0") {
            ElMessage({
              message: "删除成功",
              type: "success",
            });
            this.search = "";
            this.loading = true;
            this.load();
            this.bedDialog = false;
          } else {
            ElMessage({
              message: res.msg,
              type: "error",
            });
          }
        });
    },
    handleSearch() {
      this.currentPage = 1;
      this.load();
    },
    handleSizeChange(pageSize) {
      //改变每页个数
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.load();
    },
    handleCurrentChange(pageNum) {
      //改变页码
      this.currentPage = pageNum;
      this.load();
    },
    // 房间导入方法
    handleImportRoom() {
      this.importRoomDialogVisible = true;
      this.importRoomFile = null;
    },
    handleRoomFileChange(file) {
      this.importRoomFile = file.raw;
    },
    cancelImportRoom() {
      this.importRoomFile = null;
      this.importRoomDialogVisible = false;
      if (this.$refs.uploadRoomRef) {
        this.$refs.uploadRoomRef.clearFiles();
      }
    },
    confirmImportRoom() {
      if (!this.importRoomFile) {
        ElMessage({ message: "请选择文件", type: "warning" });
        return;
      }
      const formData = new FormData();
      formData.append("file", this.importRoomFile);
      request.post("/execl/importRooms", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      }).then((res) => {
        if (res.code === "0") {
          ElMessage({ 
            message: `导入成功：${res.data.success}条，失败：${res.data.error}条，共：${res.data.total}条`, 
            type: "success" 
          });
          this.cancelImportRoom();
          this.load();
        } else {
          ElMessage({ message: res.msg, type: "error" });
        }
      });
    },
    downloadRoomTemplate() {
      const template = [
        ['房间编号', '楼栋编号', '楼层', '最大容量', '房间类型', '备注'],
        ['3101', '3', '1', '4', 'normal', ''],
        ['3102', '3', '1', '4', 'normal', '']
      ];
      this.exportToCsv(template, '房间导入模板.csv');
    },
    exportToCsv(data, filename) {
      let csv = data.map(row => row.join(',')).join('\n');
      const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      ElMessage({ message: '模板下载成功', type: 'success' });
    },
  },
};
